import {useEffect, useState} from 'react';
// @ts-ignore
import _debounce from 'lodash.debounce';
import {get_icon} from '../ui_utils';
import zutil from 'zutil';
import hopt from 'hola_opt';

type t_get_icon = (link: string)=>string;
interface i_use_siteicon {
    link: string;
    img_load_delay?: number;
    icon_sources?: t_get_icon[];
    is_generic?: boolean;
    requester?: string;
}

export const use_siteicon = (props: i_use_siteicon)=>{
    const {img_load_delay = 100, link, is_generic, requester} = props;
    const [loaded, set_loaded] = useState(false);
    const [src, set_src] = useState(0);
    const siteicon = zutil.get(hopt, 'www_hola.siteicon.enabled');
    const icon_sources = props.icon_sources || [
        l=>get_icon(l, siteicon, is_generic && requester),
    ];
    const [icon_link, set_icon_link] = useState(!img_load_delay ?
        icon_sources && icon_sources[src](link) : null);
    const on_icon_error = event=>{
        if (!icon_sources[src+1])
        {
            event.target.onerror = null;
            return;
        }
        set_src(src+1);
    };
    const on_icon_load = ()=>set_loaded(true);
    const update_icon = ()=>icon_sources &&
        set_icon_link(icon_sources[src](link));
    const protocol_icon = icon_link && icon_link.indexOf('//')==0 ?
        'https:' : '';
    useEffect(()=>{
        if (!icon_sources || !img_load_delay)
            return;
        let debounced = _debounce(update_icon, img_load_delay);
        debounced();
        return ()=>{
            debounced.cancel();
        };
    }, [link]);
    useEffect(()=>{ !img_load_delay && update_icon(); }, [src]);
    return {
        loaded,
        on_icon_error,
        on_icon_load,
        icon_link: icon_link ? protocol_icon + icon_link : icon_link,
    };
};
